// GET /sales-crm/filters – lista zapisanych zestawów filtrów dla komponentu

import { axios } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';
import type { IWiseTableAdvancedFilter } from 'components/wise/types';

export interface ISalesCrmFilterPreset {
  id: number;
  name: string;
  filters: IWiseTableAdvancedFilter[];
  /** Widoczność kolumn – wspólne ustawienia z filtrami (GET/POST sales-crm/filters). */
  column_visibility?: Record<string, boolean>;
  /** Kolejność kolumn (field_symbol) – wspólne ustawienia z filtrami. */
  column_order?: string[];
}

export interface IGetSalesCrmFiltersResponse {
  items: ISalesCrmFilterPreset[];
}

const getSalesCrmFilters = (componentSymbol: string): Promise<IGetSalesCrmFiltersResponse> =>
  axios.get('/sales-crm/filters', { params: { component_symbol: componentSymbol } });

const queryKey = (componentSymbol: string) => ['sales-crm', 'filters', componentSymbol];

export const useGetSalesCrmFilters = (
  componentSymbol: string,
  options?: UseQueryOptions<IGetSalesCrmFiltersResponse, IError> & { enabled?: boolean }
) =>
  useQuery<IGetSalesCrmFiltersResponse, IError>(
    queryKey(componentSymbol),
    () => getSalesCrmFilters(componentSymbol),
    {
      ...options,
      enabled: (options?.enabled !== false && !!componentSymbol) ?? true
    }
  );

export { queryKey as getSalesCrmFiltersQueryKey };
